var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('Row',[_c('Column',{attrs:{"width":15}},[_c('img',{attrs:{"width":"50%","src":require("@/assets/2019/circlechek_logo.png")}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }